import Link from 'next/link';
import { getFullUrl } from './Url';
import { MouseEventHandler, ReactNode } from 'react';

interface Props {
  href: string;
  title: string | ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: MouseEventHandler<HTMLAnchorElement>;
  ariaLabel?: string;
  suppressHydrationWarning?: boolean;
}

export const renderLink = (props: Props) => {
  const {
    href,
    title,
    className,
    onClick,
    onMouseEnter,
    onMouseLeave,
    ariaLabel,
    suppressHydrationWarning,
  } = props;

  if (href?.startsWith('#')) {
    return (
      <Link
        href={href}
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        suppressHydrationWarning={suppressHydrationWarning}
        aria-label={ariaLabel}
      >
        {title}
      </Link>
    );
  }

  if (href?.startsWith('/')) {
    return (
      <Link
        href={getFullUrl(href)}
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        suppressHydrationWarning={suppressHydrationWarning}
        aria-label={ariaLabel}
      >
        {title}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      suppressHydrationWarning={suppressHydrationWarning}
      aria-label={ariaLabel}
    >
      {title}
    </a>
  );
};
